/* WARTUNGSMODUS IN DER OFFENEN SEITE (.461).
   ORIGINALTEXT MARVIN (22.10.2026)
     „dass da irgendwie Wartungsmodus oder so irgendwas steht, dass wir wieder
      sofort laden können."
   Startet die Plattform neu, während jemand die Seite offen hat, antwortet die
   API mit 503 und `wartung: true` (Caddy, handle_errors). Dann legt sich ein
   Hinweis über die Seite, es wird alle 3 Sekunden nachgefragt, und sobald die
   Plattform wieder antwortet, lädt die Seite neu. Ohne React: der Hinweis muss
   auch stehen, wenn ein Bildschirm darunter gerade nicht zeichnen kann. */
let offen = false;

export function wartungMelden(): void {
  if (offen || typeof document === 'undefined') return;
  offen = true;
  const d = document.createElement('div');
  d.setAttribute('role', 'alertdialog');
  d.style.cssText = 'position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;background:rgba(15,23,42,.55)';
  d.innerHTML = '<div style="max-width:440px;margin:16px;padding:28px 26px;background:#fff;color:#1f2a3c;border-radius:14px;text-align:center;font-family:inherit;box-shadow:0 8px 30px rgba(0,0,0,.25)">'
    + '<div style="font-weight:700;font-size:20px;margin-bottom:8px">Wartungsmodus</div>'
    + '<div style="line-height:1.5;color:#4a5568;margin-bottom:12px">Die Plattform wird gerade aktualisiert und startet neu. Die Seite lädt von selbst neu, sobald alles wieder läuft.</div>'
    + '<div id="wartung-stand" style="font-size:13px;color:#718096;margin-bottom:12px">Wird geprüft …</div>'
    + '<button type="button" style="padding:9px 18px;border:0;border-radius:8px;background:#1f3864;color:#fff;font-size:15px;cursor:pointer">Jetzt neu laden</button>'
    + '</div>';
  d.querySelector('button')!.addEventListener('click', () => location.reload());
  document.body.appendChild(d);
  let n = 0;
  const pruefen = () => {
    n++;
    fetch('/api/stand', { cache: 'no-store' })
      .then((r) => { if (r.ok) location.reload(); else weiter(); })
      .catch(weiter);
  };
  const weiter = () => {
    const s = document.getElementById('wartung-stand');
    if (s) s.textContent = `Noch nicht bereit (${n}. Versuch).`;
    setTimeout(pruefen, 3000);
  };
  setTimeout(pruefen, 2000);
}

/** Eine Antwort der Plattform lesen; erkennt den Wartungsmodus und nackte 502-Seiten. */
export function antwortLesen(status: number, text: string): any {
  let daten: any = null;
  try { daten = text ? JSON.parse(text) : null; }
  catch {
    /* KEIN JSON: eine Fehlerseite statt einer Antwort. Bei 502/503/504 ist es
       der Neustart, sonst ein echter Fehler mit verständlichem Text. */
    if (status === 502 || status === 503 || status === 504) { wartungMelden(); return { fehler: 'Die Plattform wird gerade aktualisiert.', wartung: true }; }
    return { fehler: `Die Plattform hat unerwartet geantwortet (${status}).` };
  }
  if (status === 503 && daten?.wartung) wartungMelden();
  return daten;
}
